/// <reference path="ExceptionHandling.js" />

class AssessmentMode {
	/**
	 * The container is used to get access to the DOM.
	 */
	constructor(container, assessmentOptions) {
		this.container = container;
		this.assessmentOptions = assessmentOptions;
		this.el = this.container.el;
		this.showTextMediaInitially = false;
		this.restartOverlay = this.container.el.querySelector('.restartOverlay');
		this.restartOverlay.style.display = 'none';
		this.initializeRestartClickHandlers();
	}

	/**
	 * This is the method that is called from the quiz right before the next question 
	 * is displayed. The return value indicates whether the next question should be 
	 * displayed immediately.
	 */
	customLoadEvent() {
		return true;
	}

	onSendAnswerToServerSuccess(response, rejectPromise) {
		if (response && response.page) {
			this.container.pageLoadJSON = response;
			this.container.showPage();

			this.initializeTryAgainButtonClickHandler();
			// don't need to load the next page if it's already in response
			rejectPromise();
		}
	}

	initializeTryAgainButtonClickHandler() {
		var tryAgainButton = this.el.querySelector('.tryAgain');
		if (tryAgainButton != undefined) {
			this.container.safeObserve(tryAgainButton, 'click', this.restartAssessmentGame.bind(this));
		}
	}

	initializeRestartClickHandlers() {
		this.container.safeObserve(this.el.querySelector('.restartOverlayYesButton'), 'click', this.onRestartOverlayYesClick.bind(this));
		this.container.safeObserve(this.el.querySelector('.restartOverlayNoButton'), 'click', this.onRestartOverlayNoClick.bind(this));
		this.container.safeObserve(this.el.querySelector('.restartButton'), 'click', this.onRestartClick.bind(this));
	}

	onRestartOverlayYesClick(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		this.restartAssessmentGame();
	}

	onRestartOverlayNoClick(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		this.restartOverlay.style.display = 'none';
	}

	onRestartClick(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		this.restartOverlay.style.display = '';
	}

	restartAssessmentGame(event) {
		if (event) {
			// Prevent target for clicking one more time
			jQuery(event.target).addClass("disabled");
		}
		this.restartOverlay.style.display = 'none';

		axios(this.assessmentOptions.restartURL, {
			method: 'get'
		}).then((response) => {
			this.container.updateQuestion(response.data, this.showTextMediaInitially);
		});
	}
}

Object.assign(AssessmentMode.prototype, ExceptionHandling);
